import { useMonarchRule } from "@/monarch/rules/MonarchRulesProvider";
import { SortedSearchTestData, UseSortedSearch } from "./types";

const CUSTOM_RULE_ID = "sortedSearch";

const useSortedSearch: UseSortedSearch = () => {
  const { isLoading, value } = useMonarchRule<{
    data: SortedSearchTestData;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading) {
    return {
      isLoading,
      data: {
        showSortedResults: false,
      },
    };
  }

  const variant = value?.data?.showSortedResults ? "sorted" : "control";

  return {
    isLoading,
    variant,
    data: value?.data,
  };
};

export default useSortedSearch;
